<template>
  <div class="card mt-2" style="padding: 1rem">
    <div slot="header" class="align-items-center">
      <div class="col-sm-12 col-md-12">
        <h5 class="h3 mb-0">Filtros</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-4">
          Configure quais dados deverão ser listados:
        </h6>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <label class="form-control-label d-block mb-3">Cliente</label>
            <multiselect
              :loading="loading_clients"
              v-model="client"
              :options="clients || []"
              label="name"
              track-by="id"
              :allow-empty="true"
              :preserveSearch="true"
              :showNoResults="false"
              select-label=""
              deselect-label=""
              @remove="getClients()"
              @search-change="getClients($event)"
              :clear-on-select="false"
              :placeholder="!(clients && clients.length) && !loading_clients ? `Nenhum cliente encontrado para ${currentUser.name}` : 'Selecionar um cliente'"
              :selected-label="'Selecionado'">
            </multiselect>
            <small class="form-text text-danger" v-if="props.errors.client_id">{{ props.errors.client_id }}</small>
          </div>
          <div class="col-12 col-sm-12 col-md-3" v-if="props.withAnosafras">
            <anosafra-multiselect
            v-model="value.anosafra"
            label="Ano Safra"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <badge class="badge-dot" type v-if="props.option.is_open">
                    <i class="bg-success"></i>
                  </badge>
                  <badge class="badge-dot" type v-else>
                    <i class="bg-danger"></i>
                  </badge>
                  <span class="option__title"> {{ props.option.descricao }}</span>
                </div>
              </template>
            </anosafra-multiselect>
            <small class="form-text text-danger" v-if="props.errors.anosafra_id">{{ props.errors.anosafra_id }}</small>
          </div>
        </div>
        <div slot="footer" class="row justify-content-end mr-1 mt-2">
          <base-button type="secondary" @click="emit('clear-filters')" class="mr-3" outline>Limpar Filtros</base-button>
          <base-button type="danger"  @click="emit('generate-pdf')" v-loading="props.loadingPdf" v-if="props.generatePdf" class="mr-3" outline>Gerar PDF</base-button>
          <base-button type="success" @click="emit('search')" v-loading="props.loading">Pesquisar</base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, defineEmits, onMounted, watch } from "vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import axios from "@/backend/axios/index.js";

const emit = defineEmits(["input", "search", "clear-filters"]);

const props = defineProps({
  value: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  generatePdf: {
    type: Boolean,
    required: false,
    default: false,
  },
  loadingPdf: {
    type: Boolean,
    required: false,
    default: false,
  },
  withAnosafras: {
    type: Boolean,
    required: false,
    default: false,
  },
  errors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
})

const value = computed({
  get: () => props.value,
  set: (val) => emit("input", val),
});

const currentUser = JSON.parse(localStorage.currentUser);
const loading_clients = ref(false);
const clientRequestIndex = ref(0);
const clients = ref([]);
const client = computed({
  get: () => clients.value.find((c) => c.id === value.value.client_id),
  set: (val) => {
    value.value.client_id = val && val.id;
    value.value = { ...value.value };
  },
});

const getClients = async (search, client_id) => {
  loading_clients.value = true;
  const queryData = {};
  const currentRequestIndex = ++clientRequestIndex.value;

  if (search) queryData.razao_social = search;
  if (client) queryData.id = client_id;
  queryData.salesman_id = currentUser.id;

  try {
    const response = await axios.get("/api/v1/clients", {
      params: { q: queryData, per_page: 10, },
    })

    if (currentRequestIndex !== clientRequestIndex.value) return;

    clients.value = response.data["clients"] || []
  } catch (error) {
    console.warn("[ScheduleReportsFilter][getClients]", error)
  }
  loading_clients.value = false;
};

onMounted(() => {
  getClients();
});

watch(() => value.value.anosafra, (val) => {
  value.value.anosafra_id = val.id || null;
  console.log(value.value.anosafra_id);
  
});

</script>
